export default "__VITE_ASSET__CW_Qu9wg__"